import React from "react";
import { Card, Col, Row } from "react-bootstrap";
import { Link } from "react-router-dom";
import { isMobile } from "react-device-detect";
import { useAdsChaoticOrder } from "hooks/query";
import { useSection } from "hooks/section";
import UseStartBanner from "components/StartBanner";
import SpacedList from "components/SpacedList";
import CenterSpinner from "components/CenterSpinner";
import Marker from "components/Svg/Marker";

import "./Popular.css";

export default function Popular() {
    const { data, isSuccess, isLoading } = useAdsChaoticOrder();
    const startBanner = UseStartBanner();
    console.log("startBanner", startBanner);
    return (
        <div className="Popular">
            <h2 className="mb-3">Populärt just nu!</h2>
            {isLoading && <CenterSpinner />}

            <SpacedList>
                {isSuccess &&
                    data.popularAds.$values
                        .sort((a, b) => {
                            return a.featured - b.featured;
                        })
                        .slice(0, 6)
                        .map((value, index) => {
                            let des = value.description ? value.description.substring(0, 150) + "..." : "";
                            return (
                                <React.Fragment key={value.slug}>
                                    <Item educator={{ ...value, des }} />

                                    {index === 1 && startBanner.length > 1 && (
                                        <div>
                                            <a href={startBanner[0]?.homePage} className="startBanner">
                                                <Card>
                                                    <img
                                                        className="img-fluid"
                                                        src={
                                                            isMobile
                                                                ? startBanner[0]?.smallUrl
                                                                : startBanner[0]?.largeUrl
                                                        }
                                                        loading="lazy"
                                                        alt="start-banner"
                                                    ></img>
                                                </Card>
                                            </a>
                                        </div>
                                    )}

                                    {index === 3 && startBanner.length > 1 && (
                                        <div>
                                            <a href={startBanner[1]?.homePage} className="startBanner">
                                                <Card>
                                                    <img
                                                        className="img-fluid"
                                                        src={
                                                            isMobile
                                                                ? startBanner[1]?.smallUrl
                                                                : startBanner[1]?.largeUrl
                                                        }
                                                        loading="lazy"
                                                        alt="start-banner"
                                                    ></img>
                                                </Card>
                                            </a>
                                        </div>
                                    )}
                                </React.Fragment>
                            );
                        })}
            </SpacedList>
        </div>
    );
}

function Item({ educator }) {
    const { sectionUrl } = useSection();

    const to = {
        pathname: `/${sectionUrl}/utbildning/${educator.slug}`,
        search: "",
    };

    return (
        <li>
            <Link to={to}>
                <Card className="Item">
                    <Card.Body>
                        <Row>
                            <Col sm={9} xs={7}>
                                <Card.Title>{educator.title}</Card.Title>
                                <Card.Text>{educator.description}</Card.Text>
                            </Col>

                            <Col sm={3} xs={5} className="img-container">
                                <Card.Img src={educator.logoUrl} alt="TODO" loading="lazy" />
                            </Col>
                        </Row>
                    </Card.Body>
                    <Card.Footer>
                        <p>
                            <Marker /> Ort:{" "}
                        </p>
                        {educator.locations.$values.map((value, index) => {
                            let loc = value.value;
                            if (educator.locations.$values.length - 1 === index) return <p>{loc}</p>;
                            if (educator.locations.$values.length - 1 > index && index < 2) return <p>{loc},</p>;
                        })}
                        {educator.locations.$values.length > 3 && <p>, + fler orter</p>}
                    </Card.Footer>
                </Card>
            </Link>
        </li>
    );
}
